import { createSelector } from "reselect";

import { getUserBusinessId } from "../user/user.selectors";
import * as appModels from "./app.modes";

export const getAppTheme = createSelector(
  getUserBusinessId,
  appModels.getAppTheme
);
